import { ICustomiseTabForm } from './customise-tab/CustomiseTab'
import { IAuthenticationTabForm } from './authentication-tab/AuthenticationTab'
import { INotificationTabForm } from './notifications-tab/NotificationsTab'

export enum AccountPageFormTypes {
  Customise = 'customise',
  Authentication = 'authentication',
  Notifications = 'notifications'
}

export interface AccountPageForms {
  [AccountPageFormTypes.Customise]: ICustomiseTabForm
  [AccountPageFormTypes.Authentication]: IAuthenticationTabForm
  [AccountPageFormTypes.Notifications]: INotificationTabForm
}

export interface AccountPageState {
  forms: AccountPageForms
}

export type AccountPageForm =
  | ICustomiseTabForm
  | IAuthenticationTabForm
  | INotificationTabForm
